<script lang="ts" setup>
  import { STAGE_VERSION_NAMES } from '#ourahub-intra/constants'

  import type { AppEnvironment } from '#web-oura-tools/types/auth'

  defineProps<{
    modelValue: boolean
    serviceName: string
    stage: AppEnvironment
    loading?: boolean
  }>()

  const emits = defineEmits<{
    'update:modelValue': [value: boolean]
    'confirm': []
  }>()
</script>

<template lang="html">
  <v-dialog max-width="600" :model-value="modelValue" @update:model-value="emits('update:modelValue', $event)">
    <v-card>
      <v-card-title>Create {{ STAGE_VERSION_NAMES[stage] }} version</v-card-title>

      <v-card-text>
        <p>
          You are about to create the
          <b>{{ STAGE_VERSION_NAMES[stage] }}</b>
          version of
          <b>{{ serviceName }},</b>
          which runs in {{ stage }}. Only maintainers will be able to access it.
        </p>

        <p>This makes the app accessible from OuraHub, but it does not deploy your app's code.</p>

        <ul>
          <li>
            <b>Development</b>
            always reflects your latest commits / changes automatically.
          </li>

          <li>
            <b>Experimental</b>
            and
            <b>Production</b>
            need to be manually promoted to stay up to date with Development. This can be done by running the
            <b>promote.yml</b>
            workflow in your app's GitHub repository (manually or using an AI agent).
          </li>
        </ul>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <o-btn-text text="Cancel" @click="emits('update:modelValue', false)" />
        <o-btn-primary text="Create" prepend-icon="mdi-plus" :loading="loading" @click="emits('confirm')" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
